var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"tag"},[_c('div',{staticClass:"text_label plusjakartasans-normal-white-12px"},[_vm._v("全部")])])
}]

export { render, staticRenderFns }